export function removeHash(props) {
    if (props.searchTerm.startsWith("#")) {
        props.searchTerm = props.searchTerm.slice(1)
    }
}
